import React from "react";

export const Chair = ({ style, isOccupied }) => (
  <div
    className={`chair ${isOccupied ? 'occupied' : ''}`}
    style={style}
  >
    <img src="/images/icons/chair.svg" className="w-[15px] h-[20px]"/>
  </div>
);